import React from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { getPartner } from 'packages/smart-home-support/partner';
import analyticsContext from '../../components/analytics/Analytics';

class Onboarding extends React.Component {
  componentDidMount() {
    analyticsContext
      .withAdvancedProps({
        section: 'onboarding',
      })
      .screenEvent();
  }
  render() {
    return (
      <div className="WelcomePageCotainer">
        <div className="WelcomePageCotainer__title">Welcome to {getPartner().productName}</div>
        <div className="WelcomePageCotainer__body">
          Answer 5 quick questions and we’ll set up a smart home consultation specifically for you!
        </div>
        <Link className="WelcomePageCotainer-link" to={this.props.location.pathname + '/questionnaire'}>
          <button className="WelcomePageCotainer__button">Get started</button>
        </Link>
      </div>
    );
  }
}

export default withRouter(Onboarding);



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/pages/onboarding/onboarding.js